import { render, staticRenderFns } from "./Pasaje.vue?vue&type=template&id=33f8ff84&scoped=true"
import script from "./Pasaje.vue?vue&type=script&lang=js"
export * from "./Pasaje.vue?vue&type=script&lang=js"
import style0 from "./Pasaje.vue?vue&type=style&index=0&id=33f8ff84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f8ff84",
  null
  
)

export default component.exports